import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import { publicEnv } from '@/lib/env';

export function MatchResultsCardSkeleton() {
  return (
    <div className='animate-pulse'>
      <div className='w-full pt-4 sm:pt-6'>
        {/* <div className='bg-gray-200 rounded-xl animate-pulse h-[90px] max-w-[970px] w-full mx-auto' /> */}
      </div>
      <div
        style={{
          backgroundImage: `url(${getCDNURL(
            `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/match-stats.svg`,
            1000,
            1000
          )})`,
          backgroundPosition: 'top',
          backgroundSize: 'cover',
        }}
        className='flex min-h-[416px] w-full flex-col items-center 
             px-2 sm:min-h-[484px] sm:px-4'
      >
        <div className='container mx-auto flex flex-col justify-between sm:mb-0 mb-2 mt-3'>
          {/* skeleton blocks go here */}
          <div className='container mx-auto flex justify-between sm:mb-0 mb-2'>
            <div className='w-20 h-8 bg-purple-400 rounded' />
            <div className='flex gap-2'>
              <div className='w-24 h-8 bg-purple-400 rounded' />
              <div className='w-40 h-8 bg-purple-400 rounded' />
            </div>
          </div>

          <div className='text-center mb-12 mt-2'>
            <div className='w-64 h-6 bg-purple-400 rounded mx-auto mb-2' />
            <div className='w-48 h-4 bg-purple-400 rounded mx-auto mb-1' />
          </div>
          <div className='mt-1 flex w-full flex-col justify-center sm:flex-row'>
            <div className='flex w-full text-center sm:gap-20 lg:w-1/2'>
              <div className='flex-1'>
                <div className='flex flex-col items-center'>
                  <div className='w-24 h-24 bg-purple-400 rounded-full mb-2 sm:w-48 sm:h-48' />
                  <div className='w-28 h-4 bg-purple-400 rounded' />
                </div>
              </div>
              <div className='flex'>
                <div className='w-20 h-3 bg-purple-400 rounded mx-auto' />
              </div>
              <div className='flex-1'>
                <div className='flex flex-col items-center'>
                  <div className='w-24 h-24 bg-purple-400 rounded-full mb-2 sm:w-48 sm:h-48' />
                  <div className='w-28 h-4 bg-purple-400 rounded' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mb-1 cursor-pointer border-b-4 p-4 flex justify-center gap-5 bg-black border-b-white'>
        <div className='flex flex-row items-center h-[40px] gap-1'>
          <div className='w-12 h-4 bg-gray-300 rounded' />
          <div className='w-4 h-4 bg-gray-300 rounded' />
          <div className='w-12 h-4 bg-gray-300 rounded' />
        </div>
      </div>
    </div>
  );
}
